import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { ICONS } from "./helpers";

export default function CTA() {
  return (
    <section id="request">
      <div className="wrap">
        <div className="cta-band reveal">
          <span className="eyebrow">Now accepting design partners</span>
          <h2 className="h2" style={{ marginTop: 12 }}>
            Get an invite to the private beta.
          </h2>
          <p className="lead">
            We're onboarding platform and cloud-ops teams one-by-one. Thirty minutes on a call, and if it's a fit, you'll have a Workbench in your AWS org the same week.
          </p>
          <div className="hero-cta">
            <RouterLink to="/contact" className="btn btn-primary">
              Request access
              <span dangerouslySetInnerHTML={{ __html: `<svg class="ic-svg" viewBox="0 0 24 24"><path d="${ICONS.arrow}"/></svg>` }} />
            </RouterLink>
            <RouterLink to="/docs" className="btn btn-ghost">Read the docs</RouterLink>
          </div>
          <p className="fine">SOC 2 Type II in-flight · Self-hosted option available</p>
        </div>
      </div>
    </section>
  );
}
